import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Stack, Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { BrowseCategories, type BrowseCategory } from '../../../../common/types.ts';
import messages from '../messages.ts';

const styles = cssMap({
	outerContainer: {
		paddingBlockStart: token('space.100'),
		width: '100%',
	},
	innerContainer: {
		maxWidth: '600px',
		textAlign: 'center',
	},
	noResultsTitle: {
		font: token('font.heading.small'),
	},
});

export const BrowseAgentsContentNoResults = ({
	title,
	body,
	onTabChange,
}: {
	title: string;
	body?: React.ReactNode;
	onTabChange?: (tab: BrowseCategory) => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const handleSeeAllAgents = useCallback(() => {
		onTabChange?.(BrowseCategories.ALL_AGENTS);
	}, [onTabChange]);

	return (
		<Stack xcss={styles.outerContainer} alignInline="center" space="space.200">
			<Stack space="space.050" xcss={styles.innerContainer}>
				<Box xcss={styles.noResultsTitle}>
					<Text as="p" weight="semibold">
						{title}
					</Text>
				</Box>
				{!!body && body}
			</Stack>
			{!!onTabChange && (
				<Box>
					<Button appearance="default" onClick={handleSeeAllAgents}>
						{formatMessage(messages.seeAllAgentsButton)}
					</Button>
				</Box>
			)}
		</Stack>
	);
};
